import {
  SHOW_CROPPER,
  HIDE_CROPPER,
  RECEIVE_CROPPER_IMAGE,
  CROPPER_ZOOM
} from '../constants';

const initialState = {
  visible: false,
  image: null,
  imageWidth: null,
  zoomLevel: 1,
  isZoomable: false
};

const cropper = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CROPPER:
      return { ...state, visible: true };
    case HIDE_CROPPER:
      return { ...state, visible: false };
    case RECEIVE_CROPPER_IMAGE:
      return { ...state, visible: true, ...action.imageDetails };
    case CROPPER_ZOOM:
      return { ...state, zoomLevel: action.zoom };
    default:
      return state;
  }
};

export default cropper;



// WEBPACK FOOTER //
// ./src/reducers/cropper.js